import { DEFAULT_LANG } from './i18n.js';
export const TIYIN_IN_SOUM = 100;
export function soumToTiyin(soum) {
    return Math.round(soum * TIYIN_IN_SOUM);
}
export function tiyinToSoum(tiyin) {
    return tiyin / TIYIN_IN_SOUM;
}
/**
 * Razryadlar ajratuvchisi — uzilmaydigan probel (U+00A0).
 * Oddiy probel emas: summa qator oxirida ikkiga bo'linib ketmasligi kerak.
 */
export const GROUP_SEPARATOR = '\u00A0';
/** Valyuta nomi tilga qarab: so'm / сум. */
const CURRENCY = { uz: "so'm", ru: 'сум' };
/**
 * Summani chiqaradi: `1 000 000 so'm` yoki `1 000 000 сум`.
 *
 * `Intl` natijasi Node'ning ICU to'plamiga bog'liq: to'liq ICU bo'lmagan
 * muhitda `uz-UZ` o'rniga `en-US` ishlaydi va vergul chiqadi. Shuning uchun
 * ajratuvchini o'zimiz bir xilga keltiramiz — natija har qanday serverda
 * bir xil bo'ladi.
 */
export function formatSoum(tiyin, opts = {}) {
    const { withCurrency = true, lang = DEFAULT_LANG } = opts;
    const soum = tiyinToSoum(tiyin);
    const formatted = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: Number.isInteger(soum) ? 0 : 2,
    })
        .format(soum)
        // Guruh ajratuvchisi (vergul yoki har qanday probel) → U+00A0.
        // Kasr ajratuvchisi — nuqta, u o'zgarmaydi.
        .replace(/[,\s]/g, GROUP_SEPARATOR);
    const currency = CURRENCY[lang] ?? CURRENCY[DEFAULT_LANG];
    return withCurrency ? `${formatted}${GROUP_SEPARATOR}${currency}` : formatted;
}
//# sourceMappingURL=money.js.map